import {linkFragmentToHref} from '@/modules/foundation/sanity/link/query';
import {PortableText} from '@/modules/foundation/sanity/portable-text';
import type {SiteSettingsQueryResult} from '@/sanity/schemas/types';

import type {FooterProps} from '../../components/Footer';

export const footerPropsFromSiteSettingsFragment = (
	siteSettings: SiteSettingsQueryResult,
): FooterProps => {
	const {organizationNumber, footerDescription, footerLinkGroups} = siteSettings ?? {};

	const linkGroups = footerLinkGroups?.length
		? footerLinkGroups.map((group) => {
				return {
					_key: group._key,
					title: group.heading ?? '',
					links:
						group.links?.map((link) => ({
							_key: link._key,
							href: linkFragmentToHref(link),
							title: link.title ?? '',
							targetBlank: Boolean(link.targetBlank),
						})) ?? [],
				};
			})
		: [];

	return {
		organizationNumber: organizationNumber,
		linkGroups,
		description:
			footerDescription && footerDescription.length > 0 ? (
				<PortableText value={footerDescription} />
			) : null,
	};
};
